import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { AppVariantProvider } from './contexts/AppVariantContext';
import { registerServiceWorker } from './lib/pwa/register';
import { registerVersionCheck } from './lib/versionCheck';

registerVersionCheck();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppVariantProvider variant="full">
      <App />
    </AppVariantProvider>
  </StrictMode>
);
